<div class="fake-mode-cover" *ngIf="isFakeMode"></div>
<!--<ds-tabs-->
<!--  [activeTabId]="activeTab"-->
<!--  [class.hide-header]="isFakeMode"-->
<!--  class="products-tabs"-->
<!--  [beforeContent]="manageActionsRef"-->
<!--  (onActiveTabChange)="setActiveTab($event.tabId)">-->
<!--  <ds-tab-head *ngFor="let tab of tabs"-->
<!--               [tabId]="tab?.id"-->
<!--               [activeTabId]="activeTab">-->
<!--    <span [innerHTML]="tab.title"></span>-->
<!--  </ds-tab-head>-->
<!--  <ds-tab-content [tabId]="activeTab" [activeTabId]="activeTab">-->
<!--  </ds-tab-content>-->
<!--</ds-tabs>-->
<section>
  <div class="products-list-container">
    <div class="products__mange-actions">
      <div *ngIf="!isMobile" class="actions-container">
        <ds-dropdown [value]="activeTab"
                     [dsDropdownOptions]="tabs"
                     (onFullOptionChoose)="setActiveTab($event.value)">
        </ds-dropdown>
        <ds-search-input class="products__mange-actions-search"
                         [showLoading]="showSearchLoading"
                         [formControl]="searchTerm"
                         [placeholder]="'text_searchEllipsis' | dbText"
                         [hasSearchIcon]="true"></ds-search-input>
      </div>
      <div class="db-edit-button-wrap">
        <button class="ds-btn-black"
                [routerLink]="['./add-product']"
                [ngClass]="{'ds-btn-disabled': false, 'ds-btn-medium': isMobile}">
          {{'text_productsAddProductBtn' | dbText}}
        </button>
      </div>
    </div>
    <section class="products-wrapper" id="products-wrapper">
      <db-products-table (reorder)="reorderProducts()">
        <ng-container>
          <ng-container *ngIf="products?.length; else emptyTable">
            <div class="list">
              <db-product-table-row
                *ngFor="let product of products"
                [product]="product"
                [currencySymbol]="currencySymbol"
                [websiteUrl]="websiteUrl"
                (statusChanged)="changeStatus($event)"
                (duplicateItem)="duplicateProduct($event)"
                (removeItem)="onRemoveProduct($event)">
              </db-product-table-row>
            </div>
            <div class="pagination-wrapper"
                 *ngIf="!searched">
              <ds-pagination-controls [rightNavigation]="!!isMobile"
                                      [itemsCount]="productsCount"
                                      [itemsPerPage]="productsPerPage"
                                      [currentPage]="currentPage"
                                      (onChangePage)="changePage($event)">
              </ds-pagination-controls>
            </div>
          </ng-container>
          <ng-template #emptyTable>
            <div class="empty-table"
                 *ngIf="!loading">
              <span>{{(searchTerm?.value?.length ? 'text_productsNoMatch' : 'text_productsNoProduct')|dbText}}</span>
            </div>
          </ng-template>
        </ng-container>
        <db-loading-screen [ngClass]="{'hidden':!loading}"></db-loading-screen>
      </db-products-table>
    </section>
  </div>
</section>


